var CafeComponent;

(function ($, utils) {
	var CafePreviewComponent = Vue.component('cafe-preview-vue', {
		template: '#cafe-preview-vue',
		props: ['items', 'getDataArr', 'showDetail', 'closeDetail']
	});

	var CafeDetailComponent = Vue.component('cafe-detail-vue', {
		template: '#cafe-detail-vue',
		props: ['items', 'getDataArr', 'showDetail', 'closeDetail']
	});

	var CafeListComponent = Vue.component('cafe-list-vue', {
		template: '#cafe-list-vue',
		props: ['values', 'showTooltip', 'showDetail', 'closeDetail', 'changeView']
	});

	CafeComponent = Vue.component('cafe-vue', {
		template: '#cafe-vue',
		data: function() {
			return {
				id: '',
				storeFloor: '',
				viewType: 'preview',
				values: [],
				items: [],
				action: [],
				switchData: [
					{view: 'preview', text: 'Превью'},
					{view: 'list', text: 'Список'}
				],
				hideSpinner: false
			}
		},
		components: {
			CafePreviewComponent: CafePreviewComponent,
			CafeDetailComponent: CafeDetailComponent,
			CafeListComponent: CafeListComponent
		},

		mounted: function() {
			this.mobile();
		},

		methods: {
			mobile: function() {
				var that = this,
					$detailCafe = $('.blockCafe__detail'),

					isMobile = function() {
					if (app.sizes.width < app.mobileTo) {
						$('.content').append($detailCafe);
						that.switchData = [{view: 'preview', text: 'Рестораны', icon: 'cafe'}, {view: 'list', text: 'Список', icon:'list'}];
					} else {
						that.switchData = [{view: 'preview', text: 'Превью'}, {view: 'list', text: 'Список'}];
					}
				};

				isMobile();
			},

			gotoMap: function() {
				var arr = {
					id: '',
					floor: ''
				};
				arr.id = this.id;
				arr.floor = this.storeFloor;
				return arr;
			},

			getDataArr: function(storeId, floor) {
				this.id   = storeId;
				this.storeFloor  = floor;
			},

			showTooltip: function(catIndex, storeId, id, floor) {
				vueApp.$refs.cafe.getDataArr(storeId, floor);
				this.action = this.items.filter(function(el) {
					return storeId === el.id;
				})[0];
			},

			showDetail: function(id) {
				var $box = $('.blockCafe__detail'),
					$slider = $box.find('.blockCafeSlider[data-view="detail"]'),
					$slides = $slider.find('.swiper-slide'),
					$activeSlide = $slides.filter('[data-id="'+id+'"]'),
					slideTo = $activeSlide.index() || 0,
					$prevSlider = $slider.find('.swiper-button-prev'),
					$nextSlider = $slider.find('.swiper-button-next'),
					$img = $slides.find('.swiper-img'),
					$right = $('.blockCafe__right'),
					that = this;

				$box.addClass('open');
				setTimeout(function(){
					$('html, body').addClass('overflow--detail');
				}, 500);

				var swiper = new Swiper($slider.find('.swiper-container'), {
					nextButton: $slider.find('.swiper-button-next'),
					prevButton: $slider.find('.swiper-button-prev'),
					onInit: function(swiper){
						setSize();

						if (slideTo != 0) swiper.slideTo(slideTo, 0, false);
						else swiper.setWrapperTranslate(0);

						$slider.scrollTop(0);
					}
				});

				function setSize() {
					var height = $right.height();

					if (app.sizes.width > 1020) width = $right.width()/2;
					else width = $right.width();

					if (height < width) {
					} else {
						$img.outerHeight(width*0.7931547619);
						$prevSlider.outerHeight(width*0.7931547619);
						$nextSlider.outerHeight(width*0.7931547619);
					}
				};

				$(window).on('resize', setSize);
			},

			closeDetail: function() {
				$('html, body').removeClass('overflow--detail');
				$(window).scrollTop($('.box_blockCafe').offset().top - $('.header__left').outerHeight());
				$('.blockCafe__detail').removeClass('open');
			},

			changeView: function(type, id) {
				this.viewType = type;

				var that = this;

				var isMobile = function() {
					if (app.sizes.width < app.mobileTo) {
						if (type == 'list') {
							$('html, body').animate({
								scrollTop: $('.box_blockCafe').offset().top - $('.header__left').outerHeight()
							}, 500, function(){
								$('html, body').addClass('overflow--list');
							});

							$(window).on('resize', function(){
								if (that.viewType == 'list') {
									$('html, body').removeClass('overflow--list').animate({
										scrollTop: $('.box_blockCafe').offset().top - $('.header__left').outerHeight()
										}, 0, function(){
											$('html, body').addClass('overflow--list');
									});
								}
							});
						} else {
							$('html, body').removeClass('overflow--list');
							$(window).scrollTop($('.box_blockCafe').offset().top - $('.header__left').outerHeight());
						}
					}
				};
				isMobile();
			},

			getData: function() {
				var url = '/static/components-assets/blockCafe/data.json';

				if(CommonHelpers.isDev('gold-babylon-static.denode.ru'))
					url = 'static/components-assets/blockCafe/data.json';

				if(!this.values.length) {
					this.$http
						.get(url, {
							params: {
								action: 'getCafe'
							}
						})
						.then(function(response) {
								var data    = response.body.data,
										items = [],
										that = this;

								this.values = data;

								var objImages = []; // массив со ссылками изображений

								$.each(data, function(i, cat) {
									// Первые два изображения
                  if(i === 0) {
										objImages.push({
                      loaded: false,
                      src: cat.items[0].catImg
                    },
										{
                      loaded: false,
                      src: cat.items[1].catImg
                    });
									}

									$.each(cat.items, function(i, item) {
										items.push(item);
									});
								});

								this.items = items;

                CommonHelpers.checkImgLoading(objImages)
									.then(function() {
										that.doAnimation();
									});

								this.$nextTick(function() {
									this.scriptsInit();
								});
							},
							function(response) { // Error.
								console.log('An error occurred.');
							}
						);
				}
			},

			doAnimation: function() {
				var $targetSlide = $('.blockCafeSlider[data-view="preview"]');
				$targetSlide.find('.fade-item').showItem(450);

				this.hideSpinner = true;
			},

			scriptsInit: function(id) {
				var $box         = $('.box_blockCafe'),
						$right       = $box.find('.blockCafe__right'),
						$slider      = $box.find('.blockCafeSlider'),
						$items       = $slider.find('.blockList__item'),
						$tooltip     = $box.find('.tooltip'),
						$gotoMapList = $tooltip.find('.js-gotoMap'),
						$gotoMap     = $slider.find('.js-gotoMap'),
						that         = this,

						isMobile = function() {
							if (app.sizes.width < app.mobileTo) {
								$items.on('click', function(){
									var index = $(this).attr('data-index') || 0;
									that.showDetail(index);
								});
							} else $items.off('click');
						};

				$.each($slider, function(i, el) {
					if($(el).data('view') === 'list') {
						var $scroller  = $(el).find('.js-custom-scroll'),
							$next        = $(el).find('.js-next-scroll'),
							$prev        = $(el).find('.js-prev-scroll');

						if (app.sizes.width > app.mobileTo) {
							app.utils.scroller($scroller, $prev, $next, $slider);
							app.utils.tooltip($tooltip, '.box_blockCafe .blockCafe__right');
						}

						$gotoMapList.on('click', function() {
							var arr = vueApp.$refs.cafe.gotoMap();
							CommonHelpers.searchMap(null, arr);
						});

						isMobile();

						app.dom.$window.on('resize', function() {
							isMobile();
						});
					}
					else {
						var mySwiper = new Swiper($(el).find('.swiper-container'), {
							keyboardControl: true,
							updateOnImagesReady: true,
							slidesPerView: 2,
							nextButton: $(el).find('.swiper-button-next'),
							prevButton: $(el).find('.swiper-button-prev'),
							onInit: function(){
								app.utils.slidePreview(el, 2);
								setSize(el);
							},
							onSlideChangeEnd: function(){
								app.utils.slidePreview(el, 2);
							},
							breakpoints: {
								1020: {
									slidesPerView: 1
								}
							}
						});

						function setSize(el) {
							var $slides = $(el).find('.swiper-slide'),
								$prevSlider = $(el).find('.swiper-button-prev'),
								$nextSlider = $(el).find('.swiper-button-next'),
								$img = $slides.find('.swiper-img'),
								$info = $slides.find('.swiper-info'),
								height = $right.height();

							if (app.sizes.width > 1020) width = $right.width()/2;
							else width = $right.width();

							if (height < width) {
							} else {
								$img.outerHeight(width*0.7931547619);
								$prevSlider.outerHeight(width*0.7931547619);
								$nextSlider.outerHeight(width*0.7931547619);
								$info.outerHeight(height - (width*0.7931547619));
							}
						};

						$(window).on('resize', function(){
							setSize(el);
						});

						// Переход к карте
						$gotoMap.on('click', function() {
							var arr = vueApp.$refs.cafe.gotoMap();
							CommonHelpers.searchMap(null, arr);
						});
					}
				});
			}
		}
	});
})(jQuery, app.utils);